import { AppBar, Container, Stack, Toolbar } from "@mui/material";
import { useMemo } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import OnboardingNavBar from "src/components/NavBars/OnboardingNavBar/OnboardingNavBar";
import PromoBanner from "src/components/PromoBanner";
import { MatchParam } from "src/constants/matches";
import { Paths } from "src/constants/paths";

const UpsellLayout = () => {
  const { pathname } = useLocation();
  const { questionId } = useParams<MatchParam<"QUESTION_ID">>();

  const isOTPayment = useMemo(
    () => pathname.includes(Paths.ADD_ONS),
    [pathname]
  );

  const showCountdown = useMemo(() => questionId === "6SJGE6Tr", [questionId]);

  return (
    <Stack>
      <AppBar
        position="fixed"
        sx={{
          width: `100%`,
          boxShadow: "none",
          backgroundColor: "#ffffff",
          color: "#000000",
        }}
      >
        <Stack spacing={1}>
          <OnboardingNavBar visitType={"Upsell"} />
          {isOTPayment ? <PromoBanner showCountdown={showCountdown} /> : null}
        </Stack>
      </AppBar>
      {isOTPayment ? <Toolbar /> : null}
      <Container
        disableGutters
        maxWidth="sm"
        sx={{
          flexGrow: 1,
          p: 2,
          mt: 12,
        }}
      >
        <Outlet />
      </Container>
    </Stack>
  );
};

export default UpsellLayout;
